import * as React from "react";
import type { ReactNode } from "react";
import Layout from "../components/Layout";

type RootLayoutProps = {
  children: ReactNode;
  location?: {
    pathname: string;
  };
};

export default function RootLayout({ children, location }: RootLayoutProps) {
  return <Layout location={location}>{children}</Layout>;
}

